import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import toast from 'react-hot-toast';
import ReactGA from 'react-ga';
import LogRocket from 'logrocket';

import FormControl from '@mui/material/FormControl';
import MenuItem from '@mui/material/MenuItem';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import red from '@mui/material/colors/red';

import { ColoredButton } from '../../components/Buttons/colored';
import {
  updateUserRegistrationChoices,
  userOccupation,
} from '../../store/actions/register';
import { fetchUserDetails } from '../../store/actions/user';
import {
  fetchSports,
  dispatchPageTitle,
  accessLog,
} from '../../store/actions/common';
import * as ROUTES from '../../constants/routes';
import { _lt } from '../../localization/locale';
import { Paper } from '@mui/material/';
import formImage from '../../assets/images/Best_Describe_Me.jpg';
import { useTheme } from '@mui/material/styles';
import { gt_config } from '../../configs';

const BranchingUpdate = (props) => {
  const theme = useTheme();

  const { newRole, roleText } = props.match.params;

  const classes = {
    root: {
      background:
        'linear-gradient(#d3cff620,#ffffff,#ffffff,#d3cff610,#d3cff620)',
      backgroundSize: 'cover',
      height: 'calc(100vh - 2rem)',
      overflow: 'scroll',
    },
    formWrapper: {
      width: '100%',
      maxWidth: '1200px',
      height: 'max-content',
      margin: '80px 32px 16px',
      boxShadow: '0px 10px 16px #d3cff650',
      border: '1px solid #1f1f3320',
      display: 'flex',
      flexDirection: 'row',
      overflow: 'hidden',
      [theme.breakpoints.down('md')]: {
        flexDirection: 'column',
        margin: '80px 16px 16px',
      },
    },
    formImage: {
      background: `url(${formImage}) no-repeat center`,
      backgroundSize: 'cover',
      width: '100%',
      [theme.breakpoints.down('md')]: {
        width: '100%',
        height: '300px',
        background: `url(${formImage}) no-repeat center`,
        backgroundSize: 'contain',
      },
      [theme.breakpoints.down('xs')]: {
        height: '200px',
        backgroundSize: 'cover',
      },
    },
    formContentsWrapper: {
      width: '100%',
      boxSizing: 'border-box',
      padding: '120px 32px',
      display: 'flex',
      justifyContent: 'center',
      [theme.breakpoints.down('md')]: {
        width: '100%',
        padding: '32px 60px 32px',
      },
      [theme.breakpoints.down('xs')]: {
        padding: '32px 24px 32px',
      },
    },
    buttonWrapper: {
      display: 'flex',
      marginTop: '16px',
      [theme.breakpoints.down('md')]: {
        justifyContent: 'center',
      },
    },
    submitButton: {
      width: '50%',
      borderRadius: '99px',
      backgroundColor: '#ff0000',
      [theme.breakpoints.down('sm')]: {
        width: '100%',
      },
    },
  };

  const [first, setFirst] = useState(null);
  const [secondOptions, setSecondOptions] = useState(null);
  const [second, setSecond] = useState('');
  const [thirdOptions, setThirdOptions] = useState(null);
  const [third, setThird] = useState('');
  const [isInvalid, setIsInvalid] = useState(true);
  const [showSelectionBox, setShowSelectionBox] = useState(null);
  const [showSelectionBoxOpenMessage, setShowSelectionBoxOpenMessage] =
    useState(null);
  const [isAthlete, setIsAthlete] = useState(null);
  const [newRoleForAthlete, setNewRoleForAthlete] = useState(null);

  //props.dispatchPageTitle('Getting Started | Global Talent');

  //https://dmitripavlutin.com/react-useeffect-explanation/
  useEffect(() => {
    if (props.info && props.info.hasOwnProperty('id') && (props.info.occupation || props.occupation)) {
      ReactGA.pageview(`/signup/onboard/branch/update`);
      accessLog(
        props.info.id,
        'page_view',
        'GET',
        props.location.state && props.location.state.from.pathname,
      ).catch(console.error);
      toast.success(
        _lt('Press the GT logo if you wish to go back to the main app'),
      );
    }

    if (
      !props.info ||
      (Object.keys(props.info).length > 0 && !props.info.hasOwnProperty('id'))
    ) {
      props.fetchUserDetails();
    } else {
      LogRocket.init('oa4wxt/global-talent');
      LogRocket.identify(props.info.id, {
        name: props.info.name,
        email: props.info.mail,
      });
    }
  }, []);

  useEffect(() => {
    const occ = props.info.occupation;

    if (props.info.occupation > 0) {
      setFirst(props.info.occupation);

      setIsAthlete(false);
      if ([1, 2, 3].indexOf(parseInt(occ, 10)) > -1) setIsAthlete(true);
    } else {
      setShowSelectionBox(true);
    }

    if (typeof newRole === 'undefined') {
      setShowSelectionBox(true);
    } else {
      setNewRoleForAthlete(true);
      if ([4, 5, 6, 7, 8].indexOf(parseInt(newRole, 10)) > -1) setNewRoleForAthlete(false)
    }
  }, [props.info])

  useEffect(() => {
    setSecondOptions(null);
    setThirdOptions(null);
    if (first) setIsInvalid(false);
    if (first === 1) {
      setSecondOptions([
        { code: 11, value: _lt("Have my guardian's contact info to proceed") },
        {
          code: 12,
          value: _lt("Don't have my guardian's contact info right now"),
        },
      ]);
      setIsInvalid(true);
    } else if (first === 3) {
      setSecondOptions([
        { code: 31, value: _lt('Have registered with my personal email') },
        { code: 32, value: _lt("Have registered with the minor's email") },
      ]);
      setIsInvalid(true);
    }
  }, [first]);

  useEffect(() => {
    setThirdOptions(null);
    if (second) setIsInvalid(false);
    if (second === 12) {
      toast.error(
        _lt(
          'Sorry, you cannot proceed. Please ask your parent/guardian to register.',
        ),
      );
      setIsInvalid(true);
    } else if (second === 31) {
      setThirdOptions([
        {
          code: `${second}1`,
          value: _lt(
            "Want to create the ward's account too, so handing over is easier when they grow up",
          ),
        },
        {
          code: `${second}2`,
          value: _lt(
            "No, don't want to create a personal account for the minor",
          ),
        },
      ]);
      setIsInvalid(true);
    } else if (second === 32) {
      setThirdOptions([
        {
          code: `${second}1`,
          value: _lt(
            'Want to create my personal account too, so handing over is easier when they grow up',
          ),
        },
        {
          code: `${second}2`,
          value: _lt("No, don't want to create my personal account"),
        },
      ]);
      setIsInvalid(true);
    }
  }, [second]);

  useEffect(() => {
    if (third) setIsInvalid(false);
  }, [third]);

  // TAKES CARE OF THE AUTO REDIRECT BASED ON THE info.occupation and the newrole if passed
  useEffect(() => {
    if (newRoleForAthlete !== null && isAthlete !== null && newRole !== null) {
      if (newRoleForAthlete === false && isAthlete === false) {
        switch (parseInt(newRole, 10)) {
          case 4:
            props.history.push(ROUTES.COACH_PROFILE_ADD);
            break;
          case 5:
            props.history.push(ROUTES.TEAM_PROFILE_ADD);
            break;
          case 6:
            props.history.push(ROUTES.INSTITUTE_PROFILE_ADD);
            break;
          case 7:
            props.history.push(ROUTES.SCOUT_PROFILE_ADD);
            break;
          case 8:
            window.location.assign(`${gt_config.host}getting-started/`);
            break;
          default:
            break;
        }
      } else if (newRoleForAthlete === true && isAthlete === true) {
        props.history.push(ROUTES.ATHLETE_SPORT_ADD);
      } else {
        setShowSelectionBoxOpenMessage(true);
      }
    } else if (typeof newRole === 'undefined') {
      switch (parseInt(props.info.occupation, 10)) {
        case 4:
          props.history.push(ROUTES.COACH_PROFILE_ADD);
          break;
        case 5:
          props.history.push(ROUTES.TEAM_PROFILE_ADD);
          break;
        case 6:
          props.history.push(ROUTES.INSTITUTE_PROFILE_ADD);
          break;
        case 7:
          props.history.push(ROUTES.SCOUT_PROFILE_ADD);
          break;
        case 8:
          window.location.assign(`${gt_config.host}getting-started/`);
          break;
        default:
          setShowSelectionBox(true);
          break;
      }
    }

  }, [newRole, newRoleForAthlete, isAthlete]);

  const onSubmit = (event) => {
    event.preventDefault();
    props.updateUserRegistrationChoices(`${first}-${second}-${third}`);
    if (first === props.info.occupation || first === props.occupation) {
      nextScreen();
    } else {
      props.userOccupation(first).then(async () => {
        nextScreen();
      });
    }
  };

  const nextScreen = () => {
    if (first === 2 || `${first}-${second}-${third}` === '3-32-322') {
      props.history.push(ROUTES.ATHLETE_SPORT_ADD);
    } else if (
      `${first}-${second}-${third}` === '3-31-311' ||
      `${first}-${second}-${third}` === '3-32-321' ||
      `${first}-${second}-${third}` === '1-11-'
    ) {
      props.history.push(ROUTES.SIGN_UP_GUARDIAN);
    } else {
      switch (first) {
        case 4:
          props.history.push(ROUTES.COACH_PROFILE_ADD);
          break;
        case 5:
          props.history.push(ROUTES.TEAM_PROFILE_ADD);
          break;
        case 6:
          props.history.push(ROUTES.INSTITUTE_PROFILE_ADD);
          break;
        case 7:
          props.history.push(ROUTES.SCOUT_PROFILE_ADD);
          break;
        case 8:
          window.location.assign(`${gt_config.host}getting-started/`);
          break;
        default:
          break;
      }
      //props.history.push(ROUTES.HOME);
    }
    // keep adding cases here as more role specific components are added
  };

  return (
    <Box display="flex" justifyContent="center" sx={classes.root}>
      {showSelectionBox && (
        <Paper elevation={0} sx={classes.formWrapper}>
          <Box sx={classes.formImage}></Box>
          <Box sx={classes.formContentsWrapper}>
            <form onSubmit={onSubmit}>
              <Grid spacing={1} direction="row" container>
                <Grid item xs={12}>
                  {first === null ? (
                    <Typography variant="h5" mb={1} pb={0} color="#4e4e7e">
                      {_lt('What in the following describes you best?')}
                    </Typography>
                  ) : (
                    <Typography variant="h5" mb={1} pb={0} color="#4e4e7e">
                      {_lt(
                        'Based on your registration choice, please confirm the following?',
                      )}
                    </Typography>
                  )}
                  <Typography variant="caption" display="block" gutterBottom>
                    {_lt('This information will help us guide you better')}
                  </Typography>
                </Grid>
                <Grid item xs={12}>
                  <FormControl variant="outlined">
                    <InputLabel id="first-select-label">
                      {_lt('I am')}
                    </InputLabel>
                    <Select
                      name="first"
                      value={first || props.info.occupation || props.occupation}
                      onChange={(e) => setFirst(e.target.value)}
                      placeholder={_lt('I am')}
                      label={_lt('I am')}
                      labelId="first-select-label"
                    >
                      <MenuItem key="f_1" value={1}>
                        {_lt('An athlete but below 15 years of age')}
                      </MenuItem>
                      <MenuItem key="f_2" value={2}>
                        {_lt('An athlete and 15 years or more of age')}
                      </MenuItem>
                      <MenuItem key="f_3" value={3}>
                        {_lt('A guardian opening GT account for a minor')}
                      </MenuItem>
                      <MenuItem key="f_4" value={4}>
                        {_lt('A coach')}
                      </MenuItem>
                      <MenuItem key="f_5" value={5}>
                        {_lt('An owner/admin/manager of a team')}
                      </MenuItem>
                      <MenuItem key="f_6" value={6}>
                        {_lt(
                          'An owner/admin of a club, academy or educational institute',
                        )}
                      </MenuItem>
                      <MenuItem key="f_7" value={7}>
                        {_lt('A scout')}
                      </MenuItem>
                      <MenuItem key="f_8" value={8}>
                        {_lt('An agent')}
                      </MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                {secondOptions && (
                  <Grid item xs={12}>
                    <FormControl variant="outlined">
                      <InputLabel id="second-select-label">
                        {_lt('More details')}
                      </InputLabel>
                      <Select
                        name="second"
                        label="second"
                        value={second}
                        onChange={(e) => setSecond(e.target.value)}
                        placeholder={_lt('More details')}
                      >
                        {secondOptions.map((x, i) => (
                          <MenuItem key={`s_${i}`} value={x.code}>
                            {x.value}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                )}
                {thirdOptions && (
                  <Grid item xs={12}>
                    <FormControl variant="outlined">
                      <InputLabel id="third-select-label">
                        {_lt('One last info, promise!')}
                      </InputLabel>
                      <Select
                        name="third"
                        label="third"
                        value={third}
                        onChange={(e) => setThird(e.target.value)}
                        placeholder={_lt('One last info, promise!')}
                      >
                        {thirdOptions.map((x, i) => (
                          <MenuItem key={`s_${i}`} value={x.code}>
                            {x.value}
                          </MenuItem>
                        ))}
                      </Select>
                      {`${first}-${second}-${third}` === '3-31-311' && (
                        <Typography
                          variant="subtitle2"
                          display="block"
                          gutterBottom
                        >
                          {_lt(
                            "Dont worry, all the subsequent sport related details will be linked to your ward's account",
                          )}
                        </Typography>
                      )}
                    </FormControl>
                  </Grid>
                )}
                <Grid item xs={12}>
                  <Box sx={classes.buttonWrapper}>
                    <ColoredButton
                      sx={classes.submitButton}
                      disabled={isInvalid}
                      type="submit"
                      variant="contained"
                      bgcolor={red}
                      disableElevation
                    >
                      {_lt('Next')}
                    </ColoredButton>
                  </Box>
                </Grid>
              </Grid>
            </form>
          </Box>
        </Paper>
      )}
      {showSelectionBoxOpenMessage === true && isAthlete === true && (
        <Box
          sx={{
            maxWidth: '1200px',
            height: 'max-content',
            margin: '80px 32px 16px',
          }}
        >
          <Typography variant="h5" display="block" gutterBottom>
            {`You have registered as an athlete - ${
              roleText || 'Invites'
            } can only be added by clubs, teams, academies, colleges, coaches, scouts or its administrators`}
          </Typography>
          <Link
            underline="none"
            onClick={(e) => {
              e.preventDefault();
              setShowSelectionBox(true);
              setShowSelectionBoxOpenMessage(false);
            }}
          >
            <Typography variant="caption" display="block" gutterBottom>
              {`To correct your user role, click here to complete the Getting Started guide`}
            </Typography>
          </Link>
        </Box>
      )}
      {showSelectionBoxOpenMessage === true && isAthlete === false && (
        <Box
          sx={{
            maxWidth: '1200px',
            height: 'max-content',
            margin: '80px 32px 16px',
          }}
        >
          <Typography variant="h5" display="block" gutterBottom>
            {`You have not registered as an athlete – Athlete CVs can only be added by athletes `}
          </Typography>
          <Link
            underline="none"
            display="block"
            variant="caption"
            onClick={(e) => {
              e.preventDefault();
              setShowSelectionBox(true);
              setShowSelectionBoxOpenMessage(false);
            }}
          >
            {`To correct your user role, click here to complete the Getting Started guide`}
          </Link>
        </Box>
      )}
    </Box>
  );
};

const mapStateToProps = (state) => ({
  info: state.user.info,
  occupation: state.register.occupation,
});

const mapDispatchToProps = {
  fetchUserDetails,
  fetchSports,
  updateUserRegistrationChoices,
  userOccupation,
  dispatchPageTitle,
};

const BranchingUpdateForm = withRouter(
  connect(mapStateToProps, mapDispatchToProps)(BranchingUpdate),
);

export default BranchingUpdateForm;
